import SpinwheelAccountVerification from '../../../../onboarding/components/spinwheel/SpinwheelAccountVerification';

export default function SpinwheelAccountVerificationScreen() {
    return <SpinwheelAccountVerification />;
}
